export enum MessageShowType {
  ALL = 'ALL',
  UNREAD = 'UNREAD',
  UNLOAD = 'UNLOAD'
}
